// AUTO-GENERATED by scripts/build-icon-subset.ts. Do not edit by hand.
import { MaterialIconName } from './materialIconName';

/**
 * Name → codepoint mapping for icons in MATERIAL_ICON_NAMES.
 * MaterialIcon uses this to emit Unicode codepoints (not ligature names) so
 * the @font-face unicode-range chain can route to subset or fallback font.
 */
export const ICON_CODEPOINTS: Record<MaterialIconName, string> = {
  account_balance: '\ue84f',
  account_box: '\ue851',
  account_circle: '\uf20b',
  add: '\ue145',
  add_circle: '\ue3ba',
  add_notes: '\ue091',
  alarm: '\ue855',
  approval_delegation: '\uf84a',
  arrow_back: '\ue5c4',
  arrow_forward: '\ue5c8',
  arrow_left_alt: '\uef7d',
  arrow_right_alt: '\ue941',
  arrow_upward: '\ue5d8',
  article: '\uef42',
  attach_money: '\ue227',
  auto_awesome: '\ue65f',
  award_star: '\uf612',
  balance: '\ueaf6',
  bolt: '\uea0b',
  bookmark: '\ue8e7',
  calendar_today: '\ue935',
  call: '\uf0d4',
  cancel: '\ue888',
  card_giftcard: '\ue8f6',
  category: '\ue574',
  check: '\ue5ca',
  check_circle: '\uf0be',
  checklist: '\ue6b1',
  chevron_left: '\ue5cb',
  chevron_right: '\ue5cc',
  close: '\ue5cd',
  content_copy: '\ue14d',
  contract_edit: '\uf5a1',
  credit_card: '\ue8a1',
  credit_score: '\ueff1',
  crown: '\uecb3',
  date_range: '\ue916',
  description: '\ue873',
  devices_other: '\ue337',
  diamond: '\uead5',
  directions_car: '\ueff7',
  done: '\ue876',
  download: '\uf090',
  edit: '\uf097',
  edit_note: '\ue745',
  email: '\ue159',
  emoji_objects: '\uea24',
  expand_less: '\ue5ce',
  expand_more: '\ue5cf',
  explore: '\ue87a',
  face: '\uf008',
  featured_seasonal_and_gifts: '\uef91',
  filter_none: '\ue3e0',
  flight_takeoff: '\ue905',
  flightsmode: '\uef93',
  forward_to_inbox: '\uf187',
  gpp_bad: '\uf012',
  gpp_good: '\uf013',
  group: '\uea21',
  help: '\ue8fd',
  home: '\ue9b2',
  info: '\ue88e',
  keyboard_double_arrow_right: '\ueac9',
  language: '\ue894',
  link: '\ue250',
  local_atm: '\ue53e',
  lock: '\ue899',
  loyalty: '\ue89a',
  mail: '\ue159',
  manage_search: '\uf02f',
  menu_book: '\uea19',
  neurology: '\ue10e',
  new_releases: '\uef76',
  open_in_new: '\ue89e',
  paid: '\uf041',
  person: '\uf0d3',
  phone: '\uf0d4',
  policy: '\uea17',
  public: '\ue80b',
  radio_button_checked: '\ue837',
  radio_button_unchecked: '\ue836',
  receipt_long: '\uef6e',
  redeem: '\ue8f6',
  refresh: '\ue5d5',
  remove: '\ue15b',
  remove_circle: '\uf08f',
  reply: '\ue15e',
  restaurant: '\ue56c',
  search: '\ue8b6',
  sell: '\uf05b',
  shield_with_heart: '\ue78f',
  steppers: '\ue9e7',
  stylus_fountain_pen: '\uf365',
  swap_vert: '\ue8d5',
  sync: '\ue627',
  thumb_up: '\uf577',
  train: '\ue570',
  verified: '\uef76',
  verified_user: '\uf013',
  warning: '\uf083',
};
